import { createFileRoute, Link } from '@tanstack/react-router'
import { ConfigurationCard } from '@/components/deployment/ConfigurationCard'
import { z } from 'zod'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { llmEnum } from '@/server/lib/appwrite.types'

const searchSchema = z.object({
  model: llmEnum.optional(),
  channel: z.string().optional(),
  token: z.string().optional(),
  resume: z.string().optional(),
})

export const Route = createFileRoute('/_protected/new')({
  validateSearch: (search) => searchSchema.parse(search),
  component: NewDeployment,
})

function NewDeployment() {
  const { currentUser } = Route.useRouteContext()
  const search = Route.useSearch()

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 relative">
      <div className="absolute top-8 left-8">
        <Link to="/dashboard">
          <Button
            variant="ghost"
            className="gap-2 text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Dashboard
          </Button>
        </Link>
      </div>

      <div className="w-full max-w-2xl text-center space-y-6">
        <h1 className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">
          Deploy New Instance
        </h1>
        <p className="text-muted-foreground">
          Configure your new AI assistant. Choose your model and connect your
          channels.
        </p>

        <div className="text-left">
          <ConfigurationCard
            currentUser={currentUser}
            className="max-w-xl mx-auto border-primary/20 shadow-2xl"
            initialValues={search}
            autoResume={search.resume === 'true'}
          />
        </div>
      </div>
    </div>
  )
}
